/* A gift order must include a packaging product chosen from the gift picker. */
(() => {
  const checkboxSelector = 'input[type="checkbox"][name="attributes[gift-wrapping]"]';
  const modal = document.querySelector('.gift-products-popup.modal');
  let packagingChosenFromModal = false;

  const checkboxes = () => [...document.querySelectorAll(checkboxSelector)];
  const hasPackaging = () => Boolean(document.querySelector('.cart-item.has-gift-box'));
  const setCheckboxes = (checked, disabled = false, updateDefault = false) => {
    checkboxes().forEach((input) => {
      input.checked = checked;
      input.disabled = disabled;
      if (updateDefault) input.defaultChecked = checked;
    });
  };

  const updateAttributes = async (checked, clearNote = false) => {
    const attributes = { 'gift-wrapping': checked ? 'yes' : '' };
    if (clearNote) attributes['gift-note'] = '';

    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes })
    });
    if (!response.ok) throw new Error('Unable to save gift wrapping');
    await response.json();
  };

  const failAndRestore = (wasChecked, anchor) => {
    setCheckboxes(wasChecked, false);
    console.error('Unable to save gift-wrapping selection');
    window.theme?.showQuickPopup('לא הצלחנו לשמור את הבחירה. נסו שוב.', anchor);
  };

  const cancelUnfulfilledGift = async (anchor) => {
    if (packagingChosenFromModal || hasPackaging()) return;

    packagingChosenFromModal = false;
    setCheckboxes(false, true);
    modal?.classList.remove('show-modal');
    try {
      await updateAttributes(false, true);
      document.querySelectorAll('textarea[name="attributes[gift-note]"]').forEach((input) => {
        input.value = '';
      });
      setCheckboxes(false, false, true);
    } catch (error) {
      failAndRestore(true, anchor);
    }
  };

  const dismissPicker = () => {
    modal?.classList.remove('show-modal');
    if (!packagingChosenFromModal && !hasPackaging()) void cancelUnfulfilledGift(modal);
  };

  modal?.querySelector('.close-button')?.addEventListener('click', dismissPicker);
  modal?.addEventListener('click', (event) => {
    if (event.target === modal) dismissPicker();
  });

  document.addEventListener('change', async (event) => {
    const checkbox = event.target;
    if (!checkbox.matches(checkboxSelector)) return;

    const checked = checkbox.checked;
    const wasChecked = checkbox.defaultChecked;

    if (checked && !hasPackaging()) {
      if (!modal) {
        setCheckboxes(false, false, true);
        window.theme?.showQuickPopup('כדי לסמן שההזמנה היא מתנה, יש לבחור אמצעי אריזה.', checkbox);
        return;
      }

      packagingChosenFromModal = false;
      setCheckboxes(true, true);
      modal.classList.add('show-modal');
      return;
    }

    setCheckboxes(checked, true);
    try {
      await updateAttributes(checked, !checked);
      if (!checked) {
        document.querySelectorAll('textarea[name="attributes[gift-note]"]').forEach((input) => {
          input.value = '';
        });
        modal?.classList.remove('show-modal');
      }
      setCheckboxes(checked, false, true);
    } catch (error) {
      failAndRestore(wasChecked, checkbox);
    }
  });

  document.addEventListener('on:cart:add', async (event) => {
    if (!modal?.contains(event.target)) return;

    packagingChosenFromModal = true;
    setCheckboxes(true, true);
    try {
      await updateAttributes(true);
      setCheckboxes(true, false, true);
      modal.classList.remove('show-modal');
    } catch (error) {
      packagingChosenFromModal = false;
      failAndRestore(false, modal);
      modal.classList.remove('show-modal');
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    const checkbox = checkboxes().find((input) => input.checked);
    if (checkbox && !hasPackaging()) void cancelUnfulfilledGift(checkbox);
  });
})();
